import React from 'react'
import classNames from 'classnames'
import LabelText from '../LabelText'
import CategoryUtils from "../../common/CategoryUtils";
import './index.scss'

export function getFirstImage(images) {
  if (!Array.isArray(images)) return null
  if (images[0]?.thumbnail) {
    return images[0].thumbnail
  } else {
    return images[0]?.full
  }
}

export interface IProductProps {
  className?: string
  product: any
  onClick?: any
  extras?: { [key: string]: any } | null
}

function GeneraticProductItem(props: IProductProps) {
  const { product, className, onClick, extras } = props
  const {
    id,
    name,
    nameCN,
    categoryIds,
    images,
    displayBrand,
    brand,
    brandId,
    priceTag,
    merchantInfo,
    originalPriceTag,
    inventoryStatus,
  } = product || {}

  const onDefaultClick = (e) => {
    window.open(`/discover/${id}`, '_blank')
    e.preventDefault()
  }
  
  const img = getFirstImage(images)
  return (
    <div className={classNames('generic-product-item', className)}>
      <div style={{ height: '220px' }} onClick={onClick || onDefaultClick}>
        <img className="gpi-thumbnail" alt={name} src={img?.url || ''} />
      </div>
      <div className="gpi-body">
        <LabelText label='id' value={id} />
        <LabelText label='name' value={nameCN || name} />
        <LabelText label='category' value={CategoryUtils.categoryCNById(categoryIds)} />
        <LabelText
          label='brand'
          value={(
            <span className={brandId?.length ? 'txt-black' : 'txt-gray'}>
              {displayBrand || brand}
            </span>
          )}
        />
        <LabelText label='merchant' value={
          merchantInfo ? (
            <><span><img style={{ width: 20, marginRight: 6 }} src={merchantInfo.merchantUrl} alt="merchant img" /></span><span>{merchantInfo.merchantName}</span></>
          ) : ''
        } />
        <LabelText label='price' value={(
          <React.Fragment>
            <span style={{ color: originalPriceTag ? '#1377cc' : '#333' }}>{priceTag} </span>
            <span style={{ color: '#999', textDecoration: 'line-through' }}>{originalPriceTag}</span>
          </React.Fragment>
        )} />
        <LabelText label='inventory' value={inventoryStatus || 'AVAILABLE'} />
        {
          extras && Object.keys(extras).map(key => {
            return <LabelText key={key} label={key} value={extras[key]} />
          })
        }
      </div>
    </ div>
  )
}

export default GeneraticProductItem
